/* eslint-disable no-bitwise */
export enum UserPrivilege {
  SelfExcluded = 1 << 26,
  PrivPlay = 1 << 0,
  PrivChat = 1 << 1
}
